import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_user = (params = {}) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.GETUSERLIST}`, {
    page: params.page || 1,
    page_size: params.page_size || null,
    username: params.username || '',
    email: params.email || '',
    role: params.role || '',
  });
};
